import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.css']
})
export class ErrorpageComponent implements OnInit {

  constructor(private router : Router) { }

  ngOnInit() {

    this.navigatetoTable();

  }
  navigatetoTable(){
    setTimeout(() => {
      this.router.navigateByUrl('/dashboard')
    }, 4000);
  }


}
